<template>
    <div class="text-center">
        <template  v-for="(btn, index) in args.btns">
            <button type="button"
                v-if="btn.show"
                :key="index"
                @click="btn.clickHandler(args)"
                :title="btn.tooltip"
                data-toggle="tooltip"
                :class="btn.class"
                :data-placement="!btn.tooltipPlacement ? 'top' : btn.tooltipPlacement"
                >
                <i :class="btn.icon"></i>
                {{ btn.text }}
            </button>
        </template>
    </div>
</template>

<script>
    export default {
        name: "gridBtnsTemplate",
        props: {
            args: {},
        },
        data() {
            return {

            };
        },
        mounted() {
            var container = $(this.$el);
            container.find('[data-toggle="tooltip"]').tooltip({ container });
        },
        methods: {

        }
    };
</script>
